export const CATALOG_FILTERS_KEYS = {
  codeOrName: 'codeOrName',
  productCategory: 'productCategoryIds',
  productSizes: 'sizeOptionsIds',
  collections: 'collectionsIds',
  availability: 'availability',
  deliveryWindows: 'deliveryWindowIds',
  productColor: 'productColorIds',
  colorReferences: 'colorReferencesIds',
  classifications: 'classificationsIds',
  productsWithPromotion: 'productsWithPromotion',
  onlySuggestedProducts: 'onlySuggestedProducts',
  onlyOrderAddedProducts: 'onlyOrderAddedProducts',
  sellInPriceMin: 'sellInPriceMin',
  sellInPriceMax: 'sellInPriceMax',
};
